import { __asyncGenerator, __asyncValues, __await } from "tslib";
import { AsyncIterableX } from '../asynciterablex.mjs';
import { wrapWithAbort } from './withabort.mjs';
import { throwIfAborted } from '../../aborterror.mjs';
import { isPromise } from '../../util/isiterable.mjs';
class ConcatMapAsyncIterable extends AsyncIterableX {
    constructor(_source, _selector, _thisArg) {
        super();
        this._source = _source;
        this._selector = _selector;
        this._thisArg = _thisArg;
    }
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            var _b, e_1, _c, _d, _e, e_2, _f, _g;
            throwIfAborted(signal);
            let outerIndex = 0;
            const { _thisArg: thisArg, _selector: selector } = this;
            try {
                for (var _h = true, _j = __asyncValues(wrapWithAbort(this._source, signal)), _k; _k = yield __await(_j.next()), _b = _k.done, !_b; _h = true) {
                    _d = _k.value;
                    _h = false;
                    const outer = _d;
                    const result = selector.call(thisArg, outer, outerIndex++, signal);
                    const values = (isPromise(result) ? yield __await(result) : result);
                    try {
                        for (var _l = true, _m = (e_2 = void 0, __asyncValues(wrapWithAbort(AsyncIterableX.as(values), signal))), _o; _o = yield __await(_m.next()), _e = _o.done, !_e; _l = true) {
                            _g = _o.value;
                            _l = false;
                            const inner = _g;
                            yield yield __await(inner);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (!_l && !_e && (_f = _m.return)) yield __await(_f.call(_m));
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_h && !_b && (_c = _j.return)) yield __await(_c.call(_j));
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
}
/**
 * Projects each element of an async-iterable sequence to an async-iterable sequence and merges
 * the resulting async-iterable sequences into one async-iterable sequence.
 *
 * @template TSource The type of the elements in the source sequence.
 * @template TResult The type of the elements in the projected inner sequences and the elements in the merged result sequence.
 * @param {((
 *     value: TSource,
 *     index: number,
 *     signal?: AbortSignal
 *   ) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>)} selector A transform function to apply to each element.
 * @param {*} [thisArg] Option this for binding to the selector.
 * @returns {OperatorAsyncFunction<TSource, TResult>} An operator that creates an async-iterable sequence whose
 * elements are the result of invoking the one-to-many transform function on each element of the input sequence.
 */
export function concatMap(selector, thisArg) {
    return function concatMapOperatorFunction(source) {
        return new ConcatMapAsyncIterable(source, selector, thisArg);
    };
}

//# sourceMappingURL=concatmap.mjs.map
